/* eslint-disable @typescript-eslint/no-unused-vars */
// NOTE: Imports below are kept intentionally for easy revert — see TODO comments in each route.
import { EUserAccessRoles, TUser } from '@models/user';
import {
  AllDevicePage,
  CompanyMasterListPage,
  CompanyPage,
  DevicePage,
  FileManagePage,
  FixedAssetLedger,
  HomePage,
  LayoutDiagramPage,
  LoginPage,
  ManagementSealRequest,
  MasterDataPage,
  NXIntegrationPage,
  OpenCasePage,
  ProgressReviewPage,
  PurposePage,
  StatisticsPage,
  StorePage,
  TemperatureReportPage,
  UserMasterListPage,
  FixedAssetLedgerDetail,
  AssetPhotoInquiry,
  InventoryReportPage,
  UnderDevelopmentPage,
} from '@pages';
import { SectorPage } from '@pages/SectorPage';
import { UserListPage } from '@pages/UserListPage';
import { Navigate } from 'react-router-dom';
import { TRouteType } from 'routers';
import AuthRoute from './AuthRoute';

export const adminPaths = {
  temperatureReport: '/dailyreport',
  stastictics: '/allreport',
  layoutDiagram: '/layout',
  openCase: '/detaildevice',
  masterData: '/masterdata',
  fileManagement: '/filemanage',
  allDevice: '/alldevice',
  home: '/',
  fixedAssetLedger: '/fixedassetledger',
  managementSealRequest: '/managementsealrequest',
  progressReview: '/progressreview',
  nxIntegration: '/nxintegration',
  userMasterList: '/usermasterlist',
  companyMasterList: '/companymasterlist',
  districtMasterList: '/districtmasterlist',
  storeMasterList: '/storemasterlist',
  fixedAssetLedgerDetail: '/fixedassetledger/detail',
  assetPhoto: '/fixedassetledger/photo/:assetId',
  inventoryReport: '/fixedassetledger/report',
};

const temperatureReport = '/dailyreport';
const statistics = '/allreport';
const layoutDiagram = '/layout';
const openCase = '/detaildevice';
const masterData = '/masterdata';
const fileManagement = '/filemanage';
const allDevice = '/alldevice';
const store = '/store';
const device = '/device';
const purpose = '/purpose';
const userList = '/user-list';
const company = '/company';
const home = '/';

const fixedAssetLedger = '/fixedassetledger';
const managementSealRequest = '/managementsealrequest';
const progressReview = '/progressreview';
const nxIntegration = '/nxintegration';
const userMasterList = '/usermasterlist';
const companyMasterList = '/companymasterlist';
const districtMasterList = '/districtmasterlist';
const storeMasterList = '/storemasterlist';

export const publicPaths = {
  login: '/login',
};

export const getInvalidRoute = (user: TUser | null) => {
  return {
    id: 'InvalidRoute',
    path: '*',
    element: <Navigate to={user ? home : publicPaths.login} />,
    title: user ? 'HOME' : 'LOGIN',
  };
};

export const LoginRoute: TRouteType = {
  id: '/login',
  path: publicPaths.login,
  title: 'LOGIN',
  element: <LoginPage />,
};

export const HomeRoute: TRouteType = {
  id: '/',
  path: '/',
  title: 'HOME',
  element: <HomePage />,
};

export const FixedAssetLedgerRoute: TRouteType = {
  id: fixedAssetLedger,
  path: fixedAssetLedger,
  title: 'FIXED_ASSET_LEDGER',
  element: <FixedAssetLedger />, // TODO: uncomment when ready to deploy
  // element: <UnderDevelopmentPage />,
};

// PC008 §2 対象ロール: 管理者 (ADMIN) only — 各店舗 (STORE_OWNER) bị chặn trực tiếp qua URL.
export const ManagementSealRequestRoute: TRouteType = {
  id: managementSealRequest,
  path: managementSealRequest,
  title: 'MANAGEMENT_SEAL_REQUEST',
  element: (
    <AuthRoute accessRoles={[EUserAccessRoles.ADMIN]}>
      <ManagementSealRequest />
    </AuthRoute>
  ),
};

// VAMS_PC_009 §2 対象ロール: chỉ 管理者 (ADMIN theo EUserAccessRoles) được truy cập —
// 各店舗 (STORE_OWNER) truy cập trực tiếp bằng URL phải bị chặn (UTC-TC068). Dùng lại AuthRoute
// (routers/AuthRoute.tsx) — cơ chế role-guard theo route đã có sẵn trong codebase — thay vì
// tự chế cơ chế mới.
export const ProgressReviewRoute: TRouteType = {
  id: progressReview,
  path: progressReview,
  title: 'PROGRESS_REVIEW',
  // TODO: uncomment when ready to deploy
  element: (
    <AuthRoute accessRoles={[EUserAccessRoles.ADMIN]}>
      <ProgressReviewPage />
    </AuthRoute>
  ),
  // element: <UnderDevelopmentPage />,
};

// VAMS_PC_010 §2 対象ロール: 管理者 (ADMIN) only.
export const NXIntegrationRoute: TRouteType = {
  id: nxIntegration,
  path: nxIntegration,
  title: 'NX_INTEGRATION',
  element: (
    <AuthRoute accessRoles={[EUserAccessRoles.ADMIN]}>
      <NXIntegrationPage />
    </AuthRoute>
  ),
};

export const UserMasterListRoute: TRouteType = {
  id: userMasterList,
  path: userMasterList,
  title: 'USER_MASTER_LIST',
  element: <UserMasterListPage />, // TODO: uncomment when ready to deploy
  // element: <UnderDevelopmentPage />,
};

export const CompanyMasterListRoute: TRouteType = {
  id: companyMasterList,
  path: companyMasterList,
  title: 'COMPANY_MASTER_LIST',
  element: <CompanyMasterListPage />, // TODO: uncomment when ready to deploy
  // element: <UnderDevelopmentPage />,
};

export const DistrictMasterListRoute: TRouteType = {
  id: districtMasterList,
  path: districtMasterList,
  title: 'DISTRICT_MASTER_LIST',
  element: <SectorPage />, // TODO: uncomment when ready to deploy
  // element: <UnderDevelopmentPage />,
};

export const StoreMasterListRoute: TRouteType = {
  id: storeMasterList,
  path: storeMasterList,
  title: 'STORE_MASTER_LIST',
  element: <StorePage />, // TODO: uncomment when ready to deploy
  // element: <UnderDevelopmentPage />,
};

export const FixedAssetLedgerDetailRoute: TRouteType = {
  id: '/fixedassetledger/detail/:assetId',
  path: '/fixedassetledger/detail/:assetId',
  title: 'FIXED_ASSET_LEDGER_DETAIL',
  element: <FixedAssetLedgerDetail />,
};

export const AssetPhotoInquiryRoute: TRouteType = {
  id: 'asset-photo-inquiry',
  path: adminPaths.assetPhoto,
  title: 'ASSET_PHOTO_INQUIRY',
  element: <AssetPhotoInquiry />,
};

// [Agent Proposed] Path chưa được BA/FE Lead chốt chính thức — xem analyzing-fe.md §2.3/§4 Open Item #1.
export const InventoryReportRoute: TRouteType = {
  id: 'inventory-report',
  path: adminPaths.inventoryReport,
  title: 'INVENTORY_REPORT',
  element: <InventoryReportPage />,
};

export const DailyReportRoute: TRouteType = {
  id: temperatureReport,
  path: temperatureReport,
  title: 'DAILY_REPORT',
  element: <TemperatureReportPage />,
};

export const AllReportRoute: TRouteType = {
  id: statistics,
  path: statistics,
  title: 'ALL_REPORT',
  element: <StatisticsPage />,
};

export const LayoutDiagramRoute: TRouteType = {
  id: layoutDiagram,
  path: layoutDiagram,
  title: 'LAYOUT_DIAGRAM',
  element: <LayoutDiagramPage />,
};

export const DetailDeviceRoute: TRouteType = {
  id: openCase,
  path: openCase,
  title: 'OPEN_CASE',
  element: <OpenCasePage />,
};

export const AllDeviceRoute: TRouteType = {
  id: allDevice,
  path: allDevice,
  title: 'ALL_DEVICE',
  element: <AllDevicePage />,
};

export const MasterDataRoute: TRouteType = {
  id: masterData,
  path: masterData,
  title: 'MASTER_DATA',
  element: <MasterDataPage />, // TODO: uncomment when ready to deploy
  // element: <UnderDevelopmentPage />,
};

export const FileManagementRoute: TRouteType = {
  id: fileManagement,
  path: fileManagement,
  title: 'FILE_MANAGEMENT',
  element: <FileManagePage />,
};

// Legacy aliases keep backward compatibility with existing internal links.
export const StoreRoute: TRouteType = {
  id: store,
  path: store,
  title: 'STORE',
  element: <StorePage />,
};

export const UserListRoute: TRouteType = {
  id: userList,
  path: userList,
  title: 'USER_LIST',
  element: <UserListPage />,
};

export const DeviceRoute: TRouteType = {
  id: device,
  path: device,
  title: 'DEVICE',
  element: <DevicePage />,
};

export const PurposeRoute: TRouteType = {
  id: purpose,
  path: purpose,
  title: 'PURPOSE',
  element: <PurposePage />,
};

export const CompanyRoute: TRouteType = {
  id: company,
  path: company,
  title: 'COMPANY',
  element: <CompanyPage />,
};

export const publicRoutes = [LoginRoute];
export const privateRoutes = [
  DailyReportRoute,
  AllReportRoute,
  LayoutDiagramRoute,
  DetailDeviceRoute,
  AllDeviceRoute,
  MasterDataRoute,
  FileManagementRoute,

  FixedAssetLedgerRoute,
  ManagementSealRequestRoute,
  ProgressReviewRoute,
  NXIntegrationRoute,
  UserMasterListRoute,
  CompanyMasterListRoute,
  DistrictMasterListRoute,
  StoreMasterListRoute,

  // Legacy aliases
  StoreRoute,
  DeviceRoute,
  PurposeRoute,
  UserListRoute,
  CompanyRoute,

  HomeRoute,
  FixedAssetLedgerRoute,
  FixedAssetLedgerDetailRoute,
  AssetPhotoInquiryRoute,
  InventoryReportRoute,
];
